import React, { useRef, useEffect } from 'react';

/**
 * A component that applies text color with !important priority
 * This is needed to override inherited colors from parent elements (e.g., table rows)
 */
export const ColoredText = ({ color, children, className = '', as: Tag = 'span', ...props }) => {
  const ref = useRef(null);
  
  useEffect(() => {
    if (ref.current && color) {
      ref.current.style.setProperty('color', color, 'important');
      ref.current.style.setProperty('-webkit-text-fill-color', color, 'important');
    } else if (ref.current) {
      ref.current.style.removeProperty('color');
      ref.current.style.removeProperty('-webkit-text-fill-color');
    }
  }, [color]);
  
  return (
    <Tag ref={ref} className={className} {...props}>
      {children}
    </Tag>
  );
};

export default ColoredText;
